import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCN: CultureInfo = {
  name: 'en-CN',
  displayName: 'English (China mainland)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CN',
  parent: CultureInfoEn
};
